/**
 * Normalizes quantity properties across different naming conventions
 * @param {Object} item - The item object containing quantity properties
 * @returns {number|null} - The normalized quantity value
 */
export const normalizeQuantity = (item) => {
  if (!item) return null;

  return item.maxAddToCartQuantity
    || item.max_add_to_cart_quantity
    || item.availableQuantity
    || item.available_quantity;
};
